import { Table, Tbody, Td, Tooltip, Tr } from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import { EditFormIcon, InfoFormDefault, SearchAdd, TrashIcon } from "~misc/icons";
import TableContent from "../TableContent";

const FunnelDashboardBasicTable = ({ data, id, headerValues, layoutData, handleDelete }) => {
  return (
    <div className="funnel-table-container basic-table">
      <Table className="funnel-table">
        <TableContent data={data} headerValues={headerValues} layoutData={layoutData} handleDelete={handleDelete} />
      </Table>
    </div>
  );
};

export default FunnelDashboardBasicTable;
